/* InkyStaff: detect product photos with a transparent background ("cutouts").
   Their container gets .is-cutout -> CSS drops the light plate and lets the
   product grow out of the card (pop-out effect). Photos with a white
   background keep the plate. */
(function () {
  var SEL = '.ink-pcard .pimg img, #root .l4cl > li.product-card > figure picture:first-of-type img';

  function isTransparent(img) {
    try {
      var c = document.createElement('canvas');
      var s = 24;
      c.width = s; c.height = s;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, s, s);
      var pts = [[1, 1], [s - 2, 1], [1, s - 2], [s - 2, s - 2], [s / 2, 1]];
      var clear = 0;
      for (var i = 0; i < pts.length; i++) {
        if (ctx.getImageData(pts[i][0], pts[i][1], 1, 1).data[3] < 20) clear++;
      }
      return clear >= 3;
    } catch (e) {
      return false; // cross-origin or decode problem: keep the plate
    }
  }

  function check(img) {
    if (img.dataset.inkChecked) return;
    img.dataset.inkChecked = '1';
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      if (isTransparent(probe)) {
        var box = img.closest('.pimg') || img.closest('figure');
        if (box) box.classList.add('is-cutout');
      }
    };
    probe.src = img.currentSrc || img.src;
  }

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (img) {
      if (img.complete && img.naturalWidth) check(img);
      else img.addEventListener('load', function () { check(img); }, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  // collection filters / infinite scroll / quick views re-render cards
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(scan, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* InkyStaff: variant picker fix.
   The theme keeps the other options when one is changed, so picking e.g. "RM"
   while "0.25mm / 3" is selected lands on a combination that does not exist
   (price €0,00, everything struck out). After every option change we check the
   combination and, if it does not exist, jump to the closest existing variant
   that keeps the option the customer just clicked (in-stock variants first). */
(function () {
  var form = document.querySelector('main form[action*="/cart/add"]');
  if (!form || !/\/products\//.test(location.pathname)) return;
  var handle = location.pathname.split('/products/')[1].split(/[/?#]/)[0];
  var product = null, busy = false;
  fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { product = p; refreshStates(); });

  /* The theme strikes out a value whenever it doesn't combine with ALL current
     selections (e.g. RL is struck while "21 needles" is selected), even though RL
     is in stock. Re-mark top-down instead: a value is struck out only if no
     in-stock variant has it together with the options ABOVE it. */
  // the theme re-applies its own strike-outs asynchronously (and may re-render the
  // picker) -> watch for that and correct it right after
  var fixT;
  new MutationObserver(function () {
    clearTimeout(fixT);
    fixT = setTimeout(refreshStates, 20);
  }).observe(document.querySelector('main'), { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });

  function refreshStates() {
    if (!product) return;
    var gs = groups();
    var sel = gs.map(function (g) { var c = g.radios.filter(function (r) { return r.checked; })[0]; return c ? c.value : null; });
    gs.forEach(function (g, i) {
      g.radios.forEach(function (r) {
        var ok = product.variants.some(function (v) {
          if (!v.available || v.options[i] !== r.value) return false;
          for (var j = 0; j < i; j++) if (v.options[j] !== sel[j]) return false;
          return true;
        });
        // only touch the DOM when the state is wrong (keeps the observer from looping)
        if (r.classList.contains('disabled') === ok) r.classList.toggle('disabled', !ok);
      });
    });
  }

  function groups() {
    // radio groups named options[...-<Option name>] in the theme's product form
    var out = [];
    product.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var radios = Array.prototype.filter.call(document.querySelectorAll('main input[type=radio][name^="options["]'), function (r) {
        return r.name.slice(0, -1).endsWith('-' + name) || r.name === 'options[' + name + ']';
      });
      out.push({ index: i, radios: radios });
    });
    return out;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (busy || !product || !t.matches || !t.matches('main input[type=radio][name^="options["]')) return;
    setTimeout(function () {
      var gs = groups();
      var sel = gs.map(function (g) { var c = g.radios.filter(function (r) { return r.checked; })[0]; return c ? c.value : null; });
      var exists = product.variants.some(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      // run after the theme has applied its own (too strict) strike-outs
      setTimeout(refreshStates, 80);
      if (exists) return;
      var changed = gs.findIndex(function (g) { return g.radios.indexOf(t) > -1; });
      var best = null, bestScore = -1;
      product.variants.forEach(function (v) {
        if (changed > -1 && v.options[changed] !== sel[changed]) return;
        var score = (v.available ? 100 : 0);
        v.options.forEach(function (o, i) { if (o === sel[i]) score += 10 - i; });
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (!best) return;
      busy = true;
      gs.forEach(function (g, i) {
        if (i === changed) return;
        var r = g.radios.filter(function (x) { return x.value === best.options[i]; })[0];
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      busy = false;
    }, 0);
  }, true);
})();
